export default __webpack_public_path__ + "static/media/dani-money.2afbbe89.jpeg";